import axios from 'axios'
import settings from '../../settings'

const Collections = {
    namespaced: true,
    state: () => ({
        all:[]
      }),
      mutations:{
         updateCollectionsState(state,data){
             state.all=data;
         }
      },
      actions: {
        fetchCollections({commit},{page=1,query=null,featured=0}){
          commit('updateCollectionsState',[])
            axios.get(`${settings.apiUrl}/collections?page=${page}&q=${query}&featured=${featured}`).then(res => {
				  	commit('updateCollectionsState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default Collections;

 